<template>
  <div>
    <fob-public-list-options :resourceType="resourceType"></fob-public-list-options>
    <fob-public-list-compact :resourceType="resourceType"></fob-public-list-compact>
  </div>
</template>

<script>

import PublicListCompact from '@/components/public/PublicListCompact'
import PublicListOptions from '@/components/public/PublicListOptions'

export default {
  name: 'fob-public-list-view',
  props: ['resourceType'],
  components: {
    'fob-public-list-compact': PublicListCompact,
    'fob-public-list-options': PublicListOptions
  }
}

</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/public/PublicListView.vue